<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { getDemographics } from "@/api/analytics";
import DemographChart from "@/view/components/demographics/DemographChart.vue";
// import GeoChart from "@/view/components/demographics/GeoChart.vue";
import { getIndex, setLocation } from "@/utils";
import { getLocations } from "@/api/locations";
import Multiselect from "vue-multiselect";
export default {
  name: "demographics",
  components: {
    DemographChart,
    Multiselect,
  },
  data() {
    return {
      loading: true,
      variant: "light",
      overlay: true,
      previewError: false,
      demographics: [],
      demographic: [],
      options: {},
      series: [],
      addresses: [],
      items: [],
      locations: [],
      selectedLocation: null,
      selected_location: null,
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler(to, from) {
          document.title = to.meta.title || 'Aben';
      }
    }
  },
  async beforeMount() {
  },
  async mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Demographics" }]);
    this.$store.commit("setLocationVisibile", true);
    const response = await getLocations();
    if (response) {
      this.locations = response;
      let index = getIndex(response);
      let selected = response[index];
      this.selected_location = selected;
      setLocation(selected);
    }
    setTimeout(() => {
      this.onSearch();
    }, 2000);
  },
  computed: {
    location() {
      return this.$store.getters["getSelectedLocation"];
    },
  },
  methods: {
    customLabel({ name, street }) {
      return `${name} – ${street}`;
    },
    onSearch() {
      this.loading = true;
      this.overlay = true;
      this.previewError = false;
      setTimeout(async () => {
        if (this.selected_location && this.selected_location.id) {
          const response = await getDemographics(this.selected_location.id);
          if (response) {
            if (!Object.keys(response).length) {
              this.demographics = [];
              this.demographics = [];
              this.addresses = [];
              this.demographic = [];
            } else {
              this.demographics = response;
              let keys = Object.keys(this.demographics);
              this.addresses = keys.filter(
                (key) => key === "postal code group"
              );
              this.demographic = keys.filter(
                (key) => key !== "postal code group"
              );
            }
            this.loading = false;
            this.overlay = false;
          } else {
            this.demographics = [];
            this.addresses = [];
            this.demographic = [];
            this.loading = false;
            this.previewError = true;
          }
        }
      }, 1000);
      let newVal = this.selected_location;
      let name = newVal && newVal.name ? newVal.name : "";
      let street = newVal && newVal.street ? newVal.street : "";
      let state = newVal && newVal.state ? newVal.state : "";
      this.selectedLocation = `${name} ${street} ${state}`;
    },
  },
};
</script>

<style src="@/assets/css/vue-multiselect.min.css"></style>
<style scoped>
.subheader {
  background: #e9eaf3 !important;
}
.aside-fixed.subheader-fixed .subheader {
  left: 200px;
}
.aside-minimize.subheader-fixed .subheader {
  left: 70px;
}
.content-box {
  margin-top: 40px;
}
@media only screen and (max-width: 768px) {
  .content-box {
    margin-top: 0px;
  }
}
</style>

<template>
  <v-app class="bg-transparent">
    <v-main>
      <v-overlay :value="overlay">
        <v-btn v-if="previewError" color="red" @click="overlay = false">
          Something went wrong. Please try again later.
        </v-btn>
        <div v-if="!previewError" class="text-center">
          <v-progress-circular indeterminate size="30"></v-progress-circular>
        </div>
      </v-overlay>
      <!-- Subheader start -->
      <div
        class="subheader py-2 py-lg-4 d-flex align-items-center justify-content-center"
      >
        <div class="mr-2" style="width: 350px;">
          <multiselect
            v-model="selected_location"
            placeholder="Select Locations"
            label="name"
            track-by="name"
            :options="locations"
            :custom-label="customLabel"
            :show-labels="false"
            :taggable="true"
          >
            <template slot="singleLabel" slot-scope="props">
              <div style="font-size: 14px; line-height: 13px;">
                <strong> {{ props.option.name.replace(props.option.street, '') }} </strong> <br />
                <span class="location_address">
                  {{ props.option.street }}
                  {{ props.option.city }}
                  {{ props.option.state }}
                </span>
              </div>
            </template>
            <template slot="option" slot-scope="props">
              <div style="font-family: tahoma;">
                <div style="font-size:14px">{{ props.option.name.replace(props.option.street, '') }}</div>
                <div style="font-size:11px;">
                  {{ props.option.street }}
                  {{ props.option.city }}
                  {{ props.option.state }}
                </div>
              </div>
            </template>
          </multiselect>
        </div>
        <div class="ml-2">
          <v-btn
            depressed
            color="primary"
            id="myBtn"
            @click="onSearch"
            :loading="loading"
            :disabled="loading"
          >
            <v-icon> mdi-magnify </v-icon>
          </v-btn>
        </div>
      </div>
      <!-- Subheader end -->
      <div class="content-box">
        <div v-if="demographics.length > 0">
          <h3>{{ selectedLocation }}</h3>
        </div>
        <v-row v-if="demographic">
          <v-col cols="12" sm="4" v-for="item in demographic" :key="item">
            <demograph-chart
              :item="item"
              :items="demographics"
            ></demograph-chart>
          </v-col>
        </v-row>
        <div v-if="!overlay && locations.length === 0">
          <v-alert
            color="#C51162"
            dark
            icon="mdi-material-design"
            border="right"
          >
            No locations found
          </v-alert>
        </div>
        <div v-if="!overlay && demographics.length === 0">
          <h5
            class="font-size-sm-100 font-weight-boldest text-dark-75 mt-15"
            style="font-size: 18px;"
          >
            Sorry, we can't find your data right now.
          </h5>
        </div>
        <!-- <v-row>
          <v-col cols="12" sm="4">
            <div v-for="item in addresses" :key="item">
              <demograph-chart
                :item="item"
                :items="demographics"
              ></demograph-chart>
            </div>
          </v-col>
          <v-col cols="12" sm="8">
            <geo-chart :demographics="demographics"></geo-chart>
          </v-col>
        </v-row> -->
      </div>
    </v-main>
  </v-app>
</template>
